'use strict';

angular.module('atex.dam').directive('damFixDropdownPos', [function() {
  return {
    restrict : 'A',
    link : function(scope, element, attrs) {
      var buttonElem;
      var ulElement = element.find('ul');
      element.find('button').click(function(e) {
        buttonElem = element.find('button');
        dropDownFixPosition(buttonElem, ulElement);
      });
      scope.$on('$destroy', function() {
        if (buttonElem) {
          buttonElem.off("click");
        }
        buttonElem = undefined;
      });

      function dropDownFixPosition(button, dropdown) {
        var dropDownTop = button.offset().top + button.outerHeight();
        dropdown.css('position', "fixed");
        dropdown.css('top', dropDownTop + "px");
        if (window.innerWidth<500) {
          dropdown.css('left', button.offset().left - 150 + "px");
        } else {
          dropdown.css('left', button.offset().left + "px");
        }
      }
    }
  };
  
}]);